module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"gfo_netz_overview":"netze"},"de":{"gfo_netz_overview":"Angebote"}}')
  delete Component.options._Ctor
}
